import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fontSizes } from '@/components/commons/editor/configs/ElementsConfig'
import { getTranslation } from '@/store/getters'

import styles from './styles.scss'

/** Components */
import { PopOver } from '@/components/commons/PopOver'
import IconComponent from '../../commons/IconComponent'


class FontSize extends Component {
  state = {
    showOptions: false,
  }


  render() {
    const { showOptions } = this.state
    const { onChange, label, translation } = this.props

    return (
      <div className='ba-flex ba-mg-l-1'>
        <IconComponent icon='font-size' />
        <select className={styles['select']}
          value={parseInt(label)}
          onChange={e => onChange(e.target.value)}
        >
          {fontSizes.map(size => (
            <option
              key={size}
              value={size}
            >
              {size} &nbsp;
            </option>
          ))
          }
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const translation = getTranslation(state)
  return {
    translation
  }
}


export default connect(mapStateToProps)(FontSize)



// WEBPACK FOOTER //
// ./src/components/editors/FontSize/index.js